<template>
  <div>
    <v-dialog v-model="isVisible" @keydown.esc="close" :max-width="tamanho">
      <v-card shaped elevation="10" class="p-2">
        <v-card-title>
          <v-row class=" justify-between items-center">
            <span style="font-size: 20px">{{ title }}</span>
            <v-icon size="30" :color="pegarCorTipo()">
              {{ pegarIconTipo() }}
            </v-icon>
          </v-row>
        </v-card-title>
        <v-card-text>
          <div style="font-size: 14px" v-html="message"></div>
          <v-text-field
            v-if="hasInput"
            v-model="inputValue"
            :placeholder="inputAttrs.placeholder"
            :maxlength="inputAttrs.maxlength"
            outlined
            :counter="inputAttrs.maxlength"
            :hint="!inputValue ? `obrigatorio a descrição` : ''"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="handleCancel">{{ cancelText }}</v-btn>
          <v-btn color="primary" @click="handleConfirm">{{
            confirmText
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: { type: String, required: true },
    message: { type: String, required: true },
    type: { type: String, required: true },
    onConfirm: { type: Function, required: true },
    onCancel: { type: Function, default: () => {} },
    confirmText: { type: String, default: "Confirmar" },
    cancelText: { type: String, default: "Cancelar" },
    tamanho: { default: 500 },
    hasInput: { type: Boolean, default: false },
    inputAttrs: {
      type: Object,
      default: () => ({ placeholder: "", maxlength: 255 }),
    },
  },
  data() {
    return {
      isVisible: false,
      inputValue: "", // Armazena o valor do input
    };
  },
  methods: {
    open() {
      this.isVisible = true;
    },
    close() {
      this.isVisible = false;
      this.onCancel();
    },
    handleConfirm() {
      this.onConfirm(this.inputValue);
      if (this.hasInput && !this.inputValue) {
        return;
      }
      this.isVisible = false;
    },
    handleCancel() {
      this.close();
    },
    pegarIconTipo() {
      switch (this.type) {
        case "is-success":
          return "mdi-check-circle";
        case "is-warning":
          return "mdi-alert-circle";
        case "is-error":
          return "mdi-alert";
        case "is-info":
          return "mdi-information";
        case "is-trash":
          return "mdi-delete-circle-outline";
        default:
          return "mdi-help-circle";
      }
    },
    pegarCorTipo() {
      switch (this.type) {
        case "is-success":
          return "#4CAF50";
        case "is-warning":
          return "#FFC107";
        case "is-error":
          return "#F44336";
        case "is-info":
          return "#2196F3";
        case "is-trash":
          return "#F44336";
        default:
          return "#9E9E9E";
      }
    },
  },
};
</script>

<style scoped>
/* Estilos personalizados para o modal, se necessário */
</style>
